/**
 * @function insert_welcome_error
 * @param {Boolean} insert
 */
const insert_welcome_error = ( insert ) =>
{
  insert
    ? cached_elements.get_node( '.welcome__content-copy' ).classList.add( 'error' )
    : cached_elements.get_node( '.welcome__content-copy' ).classList.remove( 'error' );

  return !insert;
}

/**
 * @function validate_welcome_input
 * @param {String} user_input - user input from the welcome input
 */
const validate_welcome_input = ( user_input ) =>
{
  return validate_string( user_input ) ? insert_welcome_error( false ) : insert_welcome_error( true );
}

/**
 * @function welcome_btns - sends the user to the hub section
 * @param {String} experience - determines if the user has added their name
 */
const welcome_btns = ( experience ) =>
{
  const personal_experience = experience === 'personalised';
  let user_input_val = cached_elements.get_node( '#js-user-name' ).value;
  let go_to_hub = personal_experience ? validate_welcome_input( user_input_val ) : true;

  go_to_hub ? update_user_name( user_input_val, personal_experience ) : false;
}

/**
 * @function update_user_name
 * @param {String} user_input_val
 */
const update_user_name = ( user_input_val, personal_experience ) =>
{
  user.name = personal_experience ? user_input_val : user.name;
  cached_elements.get_node( '.welcome' ).classList.add('visited');
  add_name_to_sections();
  const email_prefix = personal_experience ? user_input_val.replace(/ /g, '_') : 'valued_customer2967';
  document.getElementById("unsubscribe__email-input").value = `${email_prefix}@hub.com`;
  open_section( 'hub' );
}